<div class="quarter">Q<span class="pink">{{ quarter }}</span></div>
<div class="explanation" *ngIf="!disabled">Your Resources</div>
<div class="resource-wrap" [ngClass]="disabled ? 'disabled' : ''">
  <div class="img-wrap">
    <img *ngIf="!disabled" src="/assets/img/game/time.svg">
    <img *ngIf="disabled" src="/assets/img/game/time-disabled.svg">
  </div>
  <app-box [color]="disabled ? '#E6E7E8' : '#8F499C'" [title]="'Time'" [subtitle]="'(hrs per week)'">
    <div class="box-content">{{ time }}</div>
  </app-box>
</div>
<div class="resource-wrap" [ngClass]="disabled ? 'disabled' : ''">
  <div class="img-wrap">
    <img *ngIf="!disabled" src="/assets/img/game/mcc.svg">
    <img *ngIf="disabled" src="/assets/img/game/mcc-disabled.svg">
  </div>
  <app-box [color]="disabled ? '#E6E7E8' : '#2D3393'" [title]="'MCC'">
    <div class="box-content">{{ mcc }}</div>
  </app-box>
</div>
<div class="resource-wrap" [ngClass]="disabled ? 'disabled' : ''">
  <div class="img-wrap">
    <img *ngIf="!disabled" src="/assets/img/game/tposm.svg">
    <img *ngIf="disabled" src="/assets/img/game/tposm-disabled.svg">
  </div>
  <app-box [color]="disabled ? '#E6E7E8' : '#006F45'" [title]="'TPOSM'">
    <div class="box-content tposm">
      <div class="p-names tposm-header">
        <div>P1</div>
        <div>P4</div>
        <div>P5</div>
      </div>
      <div class="p-content">
        <div>{{ tposm_p1 }}</div>
        <div>{{ tposm_p4 }}</div>
        <div>{{ tposm_p5 }}</div>
      </div>
      <div class="full tposm-header"><div>Full Category</div></div>
      <div class="p-content full-value"><div>{{ tposm_full }}</div></div>
    </div>
  </app-box>
</div>
<div class="resource-wrap" [ngClass]="disabled ? 'disabled' : ''">
  <div class="img-wrap">
    <img *ngIf="!disabled" src="/assets/img/game/incentives.svg">
    <img *ngIf="disabled" src="/assets/img/game/incentives-disabled.svg">
  </div>
  <app-box [color]="disabled ? '#E6E7E8' : '#ED1C24'" [title]="'Incentives'">
    <div class="box-content">£{{ incentives }}</div>
  </app-box>
</div>